import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Fade from "react-reveal/Fade";
import Header from "../src/components/Header";
import LandingPage from "../src/components/LandingPage";
import GenerationPage from "./components/GenerationPage";
import SignInPage from "../src/components/SignInPage";
import SignUpPage from "../src/components/SignUpPage";
// import SideBar from "../src/components/SideBar";
import ChatHeader from "../src/components/ChatHeader";
import ProfileDetails from "../src/components/ProfileDetails";
import AITools from "../src/components/AITools";
import ReviewPage from "../src/components/ReviewPage";
import PricingPage from "../src/components/PricingPage";
import QuestionPage from "../src/components/QuestionPage";
import Footer from "../src/components/Footer";
import ChatBot from "../src/components/ChatBot";
import Chat from "../src/components/Chat";
import Content from "../src/components/Content";
import Experties from "../src/components/Experties";
import TextGeneration from "./components/TextGeneration";
import ImageGeneration from "./components/ImageGeneration";
import Result from "./components/Result";
import GenerationProcess from "./components/GenerationProcess";
import Playground from "./components/Playground";
import NewGeneration from "./components/NewGeneration";

import "../src/styles/Header.css";
import "../src/styles/LandingPage.css";
import "../src/styles/GenerationPage.css";
import "../src/styles/SignInPage.css";
// import "../src/styles/SideBar.css";
import "../src/styles/ChatHeader.css";
import "../src/styles/ProfileDetails.css";
import "../src/styles/ReviewPage.css";
import "../src/styles/PricingPage.css";
import "../src/styles/QuestionPage.css";
import "../src/styles/Footer.css";
import "../src/styles/AITools.css";
import "../src/styles/ChatBot.css";
import "../src/styles/Content.css";
import "../src/styles/Experties.css";
import "../src/styles/TextGeneration.css";
import "../src/styles/ImageGeneration.css";
import "../src/styles/Result.css";
import "../src/styles/Playground.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <section id="home">
                  <Fade bottom>
                    <LandingPage />
                  </Fade>
                </section>
                <section id="generation">
                  <Fade bottom>
                    <GenerationPage />
                  </Fade>
                </section>
                <section id="content">
                  <Fade bottom>
                    <Content />
                  </Fade>
                </section>
                <section id="features">
                  <Fade bottom>
                    <AITools />
                  </Fade>
                </section>
                <section id="experties">
                  <Fade bottom>
                    <Experties />
                  </Fade>
                </section>
                <section id="reviews">
                  <Fade bottom>
                    <ReviewPage />
                  </Fade>
                </section>
                <section id="pricing">
                  <Fade bottom>
                    <PricingPage />
                  </Fade>
                </section>
                <section id="faq">
                  <Fade bottom>
                    <QuestionPage />
                  </Fade>
                </section>
                <Footer />
              </>
            }
          />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          {/* <Route path="/sidebar" element={<SideBar />} /> */}
          <Route path="/chatheader" element={<ChatHeader />} />
          <Route path="/profile" element={<ProfileDetails />} />
          <Route path="/generation" element={<GenerationPage />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/chatbot" element={<ChatBot />} />
          <Route path="/text" element={<TextGeneration />} />
          <Route path="/image" element={<ImageGeneration />} />
          <Route path="/result" element={<Result />} />
          <Route path="/process" element={<GenerationProcess />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/Chat" element={<Chat />} />
          <Route path="/generation" element={<NewGeneration />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
